import { DynamicLucideKey } from './IconGlobalApp'

export const mapCommonIcons = {
  create: 'plus',
  edit: 'pen-line',
  delete: 'trash-2',
  save: 'save',
  detail: 'eye',
  filter: 'filter',
  search: 'search',
  actionTable: 'ellipsis-vertical',
  back: 'undo-2',
  submit: 'send-horizontal',
  history: 'history',
  resetFilter: 'list-restart',
  thongTin: 'user',
  sync: 'refresh-ccw',
  chamCong: 'calendar-check',
  moveRight: 'move-right',
  clock: 'clock',
  calendar: 'calendar',
  setting: 'settings',
  expandDown: 'chevron-down',
  approve: 'circle-check-big',
  requestEdit: 'pen-line',
  reject: 'circle-x',
  close: 'x',
  loadMore: 'rotate-cw',
  user: 'user-round',
  minus: 'minus',
  print: 'printer',
  dragHolder: 'grip-vertical',
  loading: 'loader-circle',
  down: 'chevron-down',
  left: 'chevron-left',
  right: 'chevron-right',
  up: 'chevron-up',
} satisfies Record<string, DynamicLucideKey>
